<template>
  <div class="waterPark">
    <div class="menuLeft">
      <ul>
        <li :class="{ move: currentIndex === index }" v-for="(item, index) in menuList" :key="index"
          @click="goShow(item, index)">
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>
    <div class="ShowOff">
      <div class="currentTitle">{{ currentTitle }}</div>
      <div class="swiper">
        <el-carousel :interval="5000" arrow="hover">
          <el-carousel-item v-for="(item, index) in currentSwiper" :key="index">
            <img class="swiperimg" :src="item.url" :alt="$t('scenic.imageAlt')" />
          </el-carousel-item>
        </el-carousel>
      </div>
        <div class="info">
          <div v-for="(item, index) in currentInfo" :key="index">{{ item }}</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    menuList() {
      return [{
          id: 15,
          value: this.$t('scenic.attractions.gemHeist'),
          info: {
            val1: this.$t('scenic.descriptions.gemHeist'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/宝石大劫案/1.jpg') }],
        },
        {
          id: 16,
          value: this.$t('scenic.attractions.trexRacing'),
          info: {
            val1: this.$t('scenic.descriptions.trexRacing'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/暴龙赛车/1.jpg') }],
        },
        {
          id: 17,
          value: this.$t('scenic.attractions.birthdayParty'),
          info: {
            val1: this.$t('scenic.descriptions.birthdayParty'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/爆笑生日趴/1.jpg') }],
        },
        {
          id: 18,
          value: this.$t('scenic.attractions.centrifuge'),
          info: {
            val1: this.$t('scenic.descriptions.centrifuge'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/欢乐离心机/1.jpg') }],
        },
        {
          id: 19,
          value: this.$t('scenic.attractions.crystalGuards'),
          info: {
            val1: this.$t('scenic.descriptions.crystalGuards'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/晶能护卫队/1.png') }],
        },
        {
          id: 20,
          value: this.$t('scenic.attractions.crystalTornado'),
          info: {
            val1: this.$t('scenic.descriptions.crystalTornado'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/晶能旋风/1.jpg') }],
        },
        {
          id: 21,
          value: this.$t('scenic.attractions.monsterChase'),
          info: {
            val1: this.$t('scenic.descriptions.monsterChase'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/巨兽追击/1.jpg') }],
        },
        {
          id: 22,
          value: this.$t('scenic.attractions.mineAdventure'),
          info: {
            val1: this.$t('scenic.descriptions.mineAdventure'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/矿井大冒险/1.jpg') }],
        },
        {
          id: 23,
          value: this.$t('scenic.attractions.mineDragonCave'),
          info: {
            val1: this.$t('scenic.descriptions.mineDragonCave'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/矿龙迷窟/1.jpg') }],
        },
        {
          id: 24,
          value: this.$t('scenic.attractions.mineDragon'),
          info: {
            val1: this.$t('scenic.descriptions.mineDragon'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/矿山飞龙/1.jpg') }],
        },
        {
          id: 25,
          value: this.$t('scenic.attractions.skyDragon'),
          info: {
            val1: this.$t('scenic.descriptions.skyDragon'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/龙翔天际/1.jpg') }],
        },
        {
          id: 26,
          value: this.$t('scenic.attractions.horseTraining'),
          info: {
            val1: this.$t('scenic.descriptions.horseTraining'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/马术训练营/1.jpg') }],
        },
        {
          id: 27,
          value: this.$t('scenic.attractions.dreamBalloon'),
          info: {
            val1: this.$t('scenic.descriptions.dreamBalloon'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/梦幻热气球/1.jpg') }],
        },
        {
          id: 28,
          value: this.$t('scenic.attractions.magicSpin'),
          info: {
            val1: this.$t('scenic.descriptions.magicSpin'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/魔力转圈圈/1.jpg') }],
        },
        {
          id: 29,
          value: this.$t('scenic.attractions.jumpingDragon'),
          info: {
            val1: this.$t('scenic.descriptions.jumpingDragon'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/魔头跳跳龙/1.jpg') }],
        },
        {
          id: 30,
          value: this.$t('scenic.attractions.policeBase'),
          info: {
            val1: this.$t('scenic.descriptions.policeBase'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/特警龙基地/1.jpg') }],
        },
        {
          id: 31,
          value: this.$t('scenic.attractions.sweetCannon'),
          info: {
            val1: this.$t('scenic.descriptions.sweetCannon'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/甜蜜礼炮/1.png') }],
        },
        {
          id: 32,
          value: this.$t('scenic.attractions.spaceExplorer'),
          info: {
            val1: this.$t('scenic.descriptions.spaceExplorer'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/星际探险家/1.jpg') }],
        },
        {
          id: 33,
          value: this.$t('scenic.attractions.iceCreamCone'),
          info: {
            val1: this.$t('scenic.descriptions.iceCreamCone'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/旋转雪糕筒/1.jpg') }],
        },
        {
          id: 34,
          value: this.$t('scenic.attractions.superCrisis'),
          info: {
            val1: this.$t('scenic.descriptions.superCrisis'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/异能危机/1.jpg') }],
        },
        {
          id: 35,
          value: this.$t('scenic.attractions.galaxyPirate'),
          info: {
            val1: this.$t('scenic.descriptions.galaxyPirate'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/银河海盗船/1.jpg') }],
        },
        {
          id: 36,
          value: this.$t('scenic.attractions.cloudWalker'),
          info: {
            val1: this.$t('scenic.descriptions.cloudWalker'),
          },
          swiperList: [{ url: require('@/assets/缤纷景区Products/云端漫步车/1.jpg') }],
        },
        {
          id: 1,
          value: this.$t('scenic.waterWorld'),
          info: {
            val1: this.$t('scenic.introText.part1'),
            val2: this.$t('scenic.introText.part2'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/恐龙水世界/1.jpg') },
            { url: require('@/assets/SecondPageImg/恐龙水世界/2.jpg') },
            { url: require('@/assets/SecondPageImg/恐龙水世界/3.jpg') },
          ],
        },
        {
          id: 2,
          value: this.$t('scenic.attractions.wavePool'),
          info: {
            val1: this.$t('scenic.descriptions.wavePool'),
          },
          swiperList: [
            {
              url: require('@/assets/SecondPageImg/造浪池/1.jpg'),
            }
          ],
        },
        {
          id: 3,
          value: this.$t('scenic.attractions.dragonCastle'),
          info: {
            val1: this.$t('scenic.descriptions.dragonCastle'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/龙门水寨/1.jpg') },
          ],
        },
        {
          id: 4,
          value: this.$t('scenic.attractions.doubleCoaster'),
          info: {
            val1: this.$t('scenic.descriptions.doubleCoaster'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/水上过山车/1.jpg') },
          ],
        },
        {
          id: 5,
          value: this.$t('scenic.attractions.greedyDragon'),
          info: {
            val1: this.$t('scenic.descriptions.greedyDragon'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/贪吃龙滑道/1.jpg') },
          ],
        },
        {
          id: 6,
          value: this.$t('scenic.attractions.sleepingDragon'),
          info: {
            val1: this.$t('scenic.descriptions.sleepingDragon'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/卧龙滑道/1.jpg') },
          ],
        },
        {
          id: 7,
          value: this.$t('scenic.attractions.timeLight'),
          info: {
            val1: this.$t('scenic.descriptions.timeLight'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/时光隧道/1.jpg') },
          ],
        },
        {
          id: 8,
          value: this.$t('scenic.attractions.wildRiver'),
          info: {
            val1: this.$t('scenic.descriptions.wildRiver'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/激情水上漂/1.jpg') },
          ],
        },
        {
          id: 9,
          value: this.$t('scenic.attractions.cobraSlide'),
          info: {
            val1: this.$t('scenic.descriptions.cobraSlide'),
          },
          swiperList: [{ url: require('@/assets/SecondPageImg/眼镜蛇滑道/1.jpg') }],
        },
        {
          id: 10,
          value: this.$t('scenic.attractions.monsterBowl'),
          info: {
            val1: this.$t('scenic.descriptions.monsterBowl'),
          },
          swiperList: [{ url: require('@/assets/SecondPageImg/巨兽碗/1.jpg') }],
        },
        {
          id: 11,
          value: this.$t('scenic.attractions.babyPool'),
          info: {
            val1: this.$t('scenic.descriptions.babyPool'),
          },
          swiperList: [{ url: require('@/assets/SecondPageImg/萌龙戏水池/1.jpg') }],
        },
        {
          id: 12,
          value: this.$t('scenic.attractions.speedSlide'),
          info: {
            val1: this.$t('scenic.descriptions.speedSlide'),
          },
          swiperList: [
            { url: require('@/assets/SecondPageImg/极速滑道/1.jpg') },
          ],
        },
        {
          id: 13,
          value: this.$t('scenic.attractions.familySlide'),
          info: {
            val1: this.$t('scenic.descriptions.familySlide'),
          },
          swiperList: [{ url: require('@/assets/SecondPageImg/合家欢滑道/1.jpg') }],
        },
        {
          id: 14,
          value: this.$t('scenic.attractions.carpetBee'),
          info: {
            val1: this.$t('scenic.descriptions.carpetBee'),
          },
          swiperList: [{ url: require('@/assets/SecondPageImg/飞毯&大黄蜂滑道/1.jpg') }],
        },
      ]
    },
    currentTitle() {
      return this.menuList[this.currentIndex]?.value || '';
    },
    currentInfo() {
      return this.menuList[this.currentIndex]?.info || {};
    },
    currentSwiper() {
      return this.menuList[this.currentIndex]?.swiperList
    }
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  methods: {
    goShow(item, index) {
      this.currentIndex = index;
    },
    scrollToMenuItem(index) {
      // 设置选中状态
      this.currentIndex = index;
      
      // 滚动到指定项
      const menuLeft = this.$el.querySelector('.menuLeft');
      const targetItem = menuLeft.querySelectorAll('li')[index];
      if (targetItem) {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
  mounted() {
    this.$parent.$on('scroll-to-item', (payload) => {
      console.log('Received payload:', payload);
      this.$nextTick(() => {
        this.scrollToMenuItem(payload.index);
      });
    });
    this.$nextTick(() => {
      // 根据路由参数或来源决定滚动到哪个项目
      const source = this.$route.query.source || this.$route.params.source;
      let targetIndex = 0; // 默认第一个项目
      
      // if (source === 'waterWorld') {
      //   // 从恐龙水世界图标点击，滚动到第二十三个项目（索引22）
      //   targetIndex = 22;
      // } else if (source === 'dreamFactory') {
      //   // 从恐龙梦工厂图标点击，滚动到第一个项目（索引0）
      //   targetIndex = 0;
      // } else {
      //   // 默认或其他情况，滚动到第一个项目（索引0）
      //   targetIndex = 0;
      // }
      
      this.scrollToMenuItem(targetIndex);
    });
  },
}
</script>

<style lang="less" scoped>
.waterPark {
  margin-top: 4.53vw; /* 87px at 1920px */
  padding: 1.56vw 0; /* 30px at 1920px */
  width: 62.5vw; /* 1200px at 1920px */
  display: flex;
  .menuLeft {
    width: 20.83vw; /* 400px at 1920px */
    height: 34.9vw; /* 670px at 1920px */
    background: #ffffff;
    border: 0.05vw solid #eee; /* 1px at 1920px */
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0.21vw; /* 4px at 1920px */
      display: block;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 0.52vw; /* 10px at 1920px */
      background: linear-gradient(#eee, #eee);
    }
    ul {
      list-style-type: none;
      font-size: 1.04vw; /* 20px at 1920px */
      color: #666666;
      // margin: 0 1.04vw; /* 20px at 1920px */
      li {
        height: 3.49vw; /* 67px at 1920px */
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1.04vw; /* 20px at 1920px */
        cursor: pointer;
        span {
          height: 3.49vw; /* 67px at 1920px */
          width: 11.46vw; /* 220px at 1920px */
          border-top: 0.05vw solid #eee; /* 1px at 1920px */
          line-height: 3.49vw; /* 67px at 1920px */
        }
      }
      li:nth-child(1) {
        span {
          border: none;
        }
      }
      .move {
        background: #85b62c;
        color: #fff;
        position: relative;
        height: 3.39vw; /* 65px at 1920px */
        &::before {
          display: block;
          content: ' ';
          background-color: #fff;
          height: 0.21vw; /* 4px at 1920px */
          width: 0.21vw; /* 4px at 1920px */
          position: absolute;
          top: 1.67vw; /* 32px at 1920px */
          left: 2.08vw; /* 40px at 1920px */
        }
        &::after {
          display: block;
          content: ' ';
          background-color: #fff;
          height: 4px;
          width: 4px;
          position: absolute;
          top: 32px;
          right: 40px;
        }
      }
    }
  }
  .ShowOff {
    width: 100%;
    height: 100%;
    margin: 0 1.72vw; /* 33px at 1920px */
    .currentTitle {
      height: 3.39vw; /* 65px at 1920px */
      line-height: 3.39vw; /* 65px at 1920px */
      width: 100%;
      font-size: 1.15vw; /* 22px at 1920px */
      color: #583c3c;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1.04vw; /* 20px at 1920px */
      
      &::before {
        content: '';
        flex: 1;
        max-width: 6.25vw; /* 120px at 1920px */
        height: 0.31vw; /* 6px at 1920px */
        background: #85b62c;
        border-radius: 0.16vw; /* 3px at 1920px */
      }
      
      &::after {
        content: '';
        flex: 1;
        max-width: 6.25vw; /* 120px at 1920px */
        height: 0.31vw; /* 6px at 1920px */
        background: #85b62c;
        border-radius: 0.16vw; /* 3px at 1920px */
      }
    }
    .swiper {
      display: flex;
      justify-content: center;
      margin-bottom: 1.56vw; /* 30px at 1920px */
      .el-carousel {
        border-radius: 1.04vw; /* 20px at 1920px */
      }
      .el-carousel__arrow {
        background: #fff;
        opacity: 0.5;
        color: green;
        width: 3.13vw; /* 60px at 1920px */
        height: 3.13vw; /* 60px at 1920px */
        font-size: 1.04vw; /* 20px at 1920px */
        &:hover {
          opacity: 0.75;
        }
      }
      /deep/ .el-carousel .el-carousel__container {
        height: 20.83vw; /* 400px at 1920px */
        width: 36.46vw; /* 700px at 1920px */
      }
      .swiperimg {
        height: 20.83vw !important; /* 400px at 1920px */
        width: 36.46vw !important; /* 700px at 1920px */
      }
    }
    .info {
      text-align: left;
      text-indent: 2em;
      color: #583c3c;
      font-size: 0.73vw; /* 14px at 1920px */
      line-height: 2.08vw; /* 40px at 1920px */
    }
  }
}
</style>
